import state from './state.js'
import actions from './actions.js'

export default {
    state,
    actions,
}
